/**
 * Exports dropdown list-related design tokens
 */

export const closeDelay = 'short';
export const collapseHorizontalPadding = true;